import { useState } from "react";
import useDeliveryPickupAxios, { useDeliveryPickupFormData } from "../utils/axios";
import { useDispatch } from "react-redux";
import { setData, setError, setIsLoading } from "../features/roleAndPermissionsSlice";
import { config } from "../utils/Constants";


function useRolesAndPermissions() {

    const DeliveryPortalAxios = useDeliveryPickupAxios();
    const DeliveryPortalAxios1 = useDeliveryPickupFormData();
    const DeliveryPortalClient = DeliveryPortalAxios;
    DeliveryPortalClient.defaults.timeout = 600000;
    const DeliveryPortalClient1 = DeliveryPortalAxios1;
    DeliveryPortalClient1.defaults.timeout = 600000;

    const dispatch = useDispatch();

    const Token = sessionStorage.getItem("Token");

    const URL = config.url

    const fetchRolesAndPermissions = async () => {
        if (!sessionStorage.getItem("Features")) {
            const token = sessionStorage.getItem("Token");
            try {
                dispatch(setIsLoading());
                const response = await DeliveryPortalAxios.get(
                    `${URL}/Authentication/RolesAndPermissions`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                            "X-SESSION-ID": sessionStorage.getItem("SessionID"),
                        },
                        withCredentials: true,
                    }
                );

                sessionStorage.setItem("Features", JSON.stringify(response.data.payload));
                dispatch(setData(response.data.payload));
                return response.data.payload;
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    dispatch(setError("Unauthorized"));
                    throw new Error("Unauthorized");
                }
                dispatch(setError(error.message));
                throw new Error(error.message);
            }
        } else {
            const features = JSON.parse(sessionStorage.getItem("Features"));
            dispatch(setData(features));
            return features;
        }
    };

    return {
        fetchRolesAndPermissions,
    }
}

export default useRolesAndPermissions;